module.exports = __webpack_public_path__ + "static/media/vueweather.82652bb4.webp";